__turbopack_context__.v({
  "link": "NavigationMobile-module__B7NiHq__link",
  "list": "NavigationMobile-module__B7NiHq__list",
  "root": "NavigationMobile-module__B7NiHq__root",
  "selected": "NavigationMobile-module__B7NiHq__selected",
});
